export default "__VITE_ASSET__Bfzj6CHt__"